import React, { PureComponent } from 'react';
import connect from '@active/awe-ui-core/lib/hoc/connect';
import Spinner from '@active/awe-ui-core/lib/components/Spinner';
import Row from 'react-aaui/lib/grid/Row';
import Col from 'react-aaui/lib/grid/Col';
import { getLocale } from 'modules/app/selector';
import Event from 'components/Event/Event';
import { getRecentEvents } from '../duck/selector';
import './RecentEvents.scss';

export class RecentEvents extends PureComponent {
  render() {
    return (
      <div className="recent-events">
        {
          this.props.loadingRecentEvents
            ? <Spinner />
            : <Row gutter={10} fluid>
              {
                this.props.events.map((e) => {
                  return (
                    <Col sm={6} className="recent-events__item" key={e.applicationName}>
                      <Event locale={this.props.locale} {...e} />
                    </Col>
                  );
                })
              }
            </Row>
        }
      </div>
    );
  }
}
const mapState = (state) => {
  return {
    events: getRecentEvents(state),
    locale: getLocale(state),
    loadingRecentEvents: state.getIn([ 'homePage', 'loadingRecentEvents' ]),
  };
};

export default connect(mapState, null)(RecentEvents);
